"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var ProductService_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductService = void 0;
const typeorm_1 = require("typeorm");
const data_ui_1 = require("../data-ui");
const layouts_1 = require("../data-ui/layouts");
const events_1 = require("../events");
const contact_profile_enum_1 = require("./contact-profile-enum");
const link_type_1 = require("./link-type");
const product_1 = require("./product");
const service_1 = require("./service");
let ProductService = ProductService_1 = class ProductService {
};
ProductService.EVENTS = (0, events_1.makeEventsForClass)(ProductService_1);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ generated: true }),
    data_ui_1.DataUi.SearchField(),
    (0, typeorm_1.PrimaryGeneratedColumn)({
        type: 'bigint',
        name: 'id',
    }),
    __metadata("design:type", String)
], ProductService.prototype, "id", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.SearchField(),
    (0, typeorm_1.ManyToOne)(() => product_1.Product, { nullable: false }),
    (0, typeorm_1.JoinColumn)({ name: 'product_id' }),
    __metadata("design:type", product_1.Product)
], ProductService.prototype, "product", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ label: 'Linked Service' }),
    data_ui_1.DataUi.SearchField(),
    (0, typeorm_1.ManyToOne)(() => service_1.Service, { nullable: false }),
    (0, typeorm_1.JoinColumn)({ name: 'service_id' }),
    __metadata("design:type", service_1.Service)
], ProductService.prototype, "service", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ label: 'Link Type' }),
    data_ui_1.DataUi.EnumValues(link_type_1.ServiceLinkTypeEnum),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: link_type_1.ServiceLinkTypeEnum,
        nullable: true,
    }),
    __metadata("design:type", String)
], ProductService.prototype, "linkType", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)({
        type: 'float',
        nullable: true,
    }),
    __metadata("design:type", Number)
], ProductService.prototype, "quantity", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)({
        type: 'bigint',
        name: 'product_id',
    }),
    __metadata("design:type", Number)
], ProductService.prototype, "productId", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)({
        type: 'character varying',
        name: 'service_id',
        length: 18,
    }),
    __metadata("design:type", String)
], ProductService.prototype, "serviceId", void 0);
ProductService = ProductService_1 = __decorate([
    data_ui_1.DataUi.Permissions({
        read: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
        write: [contact_profile_enum_1.ContactProfileEnum.PRODUCT, contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER],
    }),
    data_ui_1.DataUi.Name({
        name: 'Product Service',
        nameFunction: (i) => { var _a, _b; return `${(_a = i.product) === null || _a === void 0 ? void 0 : _a.name}@${(_b = i.service) === null || _b === void 0 ? void 0 : _b.name}`; },
    }),
    data_ui_1.DataUi.DefaultLayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Entity)('product_service', { schema: 'public' })
], ProductService);
exports.ProductService = ProductService;
//# sourceMappingURL=product-service.js.map